export const POST_FORM_COLLECTION = "POST_FORM_COLLECTION";
export const END_FORM_COLLECTION = "END_FORM_COLLECTION";
export const SOLUTIONS_COLLECTION = "SOLUTIONS_COLLECTION";
export const GENERAL_DOWNTIME_COLLECTION = "GENERAL_DOWNTIME_COLLECTION";
